module.exports = function() {
  return new Worker(__webpack_public_path__ + "bec7ceb1fd7ba4d552e3.worker.js");
};